module.exports = __webpack_public_path__ + "static/media/logo2.569dce34.png";